import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, TextField } from "@mui/material";
function ThemeChip(props) {
  const { theme, defaultTheme, onDelete, onLoad, active } = props;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        "&::before": {
          background: (theme2) => active ? theme2.vars.palette.info.main : "transparent",
          content: '""',
          height: "100%",
          left: 0,
          opacity: 0.8,
          position: "absolute",
          top: 0,
          width: "100%"
        },
        display: "flex",
        flexDirection: "column",
        gap: 2,
        padding: 2,
        position: "relative"
      },
      children: [
        /* @__PURE__ */ jsx(
          TextField,
          {
            disabled: true,
            label: props.name,
            multiline: true,
            slotProps: {
              input: {
                sx: {
                  fontSize: 12,
                  height: 300,
                  overflow: "auto"
                }
              }
            },
            sx: { width: 200 },
            type: "textarea",
            value: JSON.stringify(theme, null, 2),
            variant: "filled"
          }
        ),
        /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", justifyContent: "space-between" }, children: [
          /* @__PURE__ */ jsx(Button, { color: "primary", disabled: active, onClick: onLoad, variant: "contained", children: "Load" }),
          /* @__PURE__ */ jsx(Button, { color: "error", disabled: defaultTheme, onClick: onDelete, variant: "contained", children: "Delete" })
        ] })
      ]
    }
  );
}
export {
  ThemeChip
};
//# sourceMappingURL=ThemeChip.js.map
